import { useTranslation } from "../../i18n/hooks/useTranslation";
import styles from '../../pages/auth/login/LoginPage.module.scss';

function SideImage() {
  const { t } = useTranslation();

  const year = new Date().getFullYear();
  return (
    <div>
      <img src="/images/authImage.svg" style={{ width: "100%", maxWidth: "75%", objectFit: "contain", display: "block", margin: "0 auto" }} />
      <p style={{ fontSize: "1.125rem", textAlign: "center" }} className={styles.brandingTagline}>
        {t("auth.createDocumentEasily")}
      </p>
    </div>
  );
}

export default SideImage;
